// Basically a ripoff of https://github.com/mbrevda/react-image/blob/master/src/index.js. They aren't updating to remove
// deprecated React functions, so I'm taking matters into my own hands.
import { Spinner } from "./Spinner";
import React, { useEffect, useState } from "react";
import * as R from "ramda";

interface ImgProps {
  src: string;
  unloader?: React.ReactNode;
  spinnerSize?: number;
  className?: string;
  alt?: string;
  backupSrcs?: string[];
  [passthrough: string]: any;
}

const EMPTY_BACKUP_SRCS: string[] = [];

export const Img = ({
  src,
  unloader = <span />,
  spinnerSize = 20,
  className = "",
  alt = "",
  backupSrcs = EMPTY_BACKUP_SRCS,
  ...props
}: ImgProps): JSX.Element => {
  const [imgSrc, setImgSrc] = useState<string>();
  const [loadingState, setLoadingState] = useState("loading");

  useEffect(() => {
    if (src) {
      setImgSrc(undefined);
      setLoadingState("loading");
    }
  }, [src]);

  useEffect(() => {
    const srcsToTry = [src, ...backupSrcs];
    if (R.isNil(imgSrc) || !srcsToTry.includes(imgSrc)) {
      const imageExists = false;
      for (const src of srcsToTry) {
        let exit = false;
        const img = new Image();
        img.src = src;
        img.onload = () => {
          setImgSrc(src);
          setLoadingState("loaded");
          exit = true;
        };
        if (exit) {
          break;
        }
      }
      if (!imageExists) {
        setLoadingState("error");
      }
    }
  }, [backupSrcs, imgSrc, src]);

  switch (loadingState) {
    case "loaded":
      return <img {...props} alt={alt} src={imgSrc} className={className} />;
    case "loading":
      return <Spinner size={spinnerSize} />;
    case "error":
      return <>{unloader}</>;
    default:
      return <span />;
  }
};

export default Img;
